<template>
  <mb-panel>
    <mb-section>
      <div class="HeroContactWrapper">
        <div class="HeroContact" v-if="!isAirplusModule">          
            <h1 class="HeroContact--title" v-html="$i18n.t('requestfailed.page.title')" >Vielen Dank</h1>
            <p class="HeroContact--lead" v-if="isDevelopmentEnvironment">{{requestStatus}}</p>
            <p class="HeroContact--lead" v-html="$i18n.t('requestfailed.page.content')">Besten Dank für Ihre Anfrage.</p>         
        </div>
        <div class="HeroContact" v-if="isAirplusModule">          
            <h1 class="HeroContact--title" v-html="$i18n.t('airplus.requestfailed.page.title')">Wir haben Ihre Bestellung erhalten</h1>
            <p class="HeroContact--lead" v-if="isDevelopmentEnvironment">{{requestStatus}}</p>
            <p class="HeroContact--lead" v-html="$i18n.t('airplus.requestfailed.page.content')">Gerne prüfen wir Ihren Antrag. Sofern die Daten korrekt sind, erhalten Sie Ihr Ersatzgerät in einigen Tagen.</p>          
        </div>
      </div>
    </mb-section>
  </mb-panel>
</template>
<script>  
import Service from '@/service/backend-api';
import { mapGetters } from "vuex";
  
export default {
    name: 'ActivationResponse',
    props: { 
    },
    data() {
      return {
        isDevelopmentEnvironment: false,
        requestStatus: null,
      }
    },
    created() {
      this.init();
      console.log('ActivationRespone Component Created : ');
    },
    computed : {
          ...mapGetters(["isAirplusModule"])
    },
     methods : {
      init: function(){
          Service.getEnvironment().then(({ data }) => { 
            if(data == "dev")
              this.isDevelopmentEnvironment=true;
            console.log(this.isDevelopmentEnvironment);
        })
        .catch(error => {
          console.log(error.response.data);
        });
      },
     }
  }
</script>
